import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { IRootState } from "@/store/types";
import { REFERENCE_DATA, referenceData } from "./referenceData";
import { STANDARD_OFFER, standardOffer } from "./standardOffer";
import { UI, ui } from "./ui";
import { PROMO_CODES, promoCodes } from "./promoCodes";
import { APPLICATION, application } from "./applications";
import { TASK, task } from "./task";
import { AUTH, auth } from "./auth";
import { ADDRESS_LOOKUP, addressLookup } from "./addressLookup";
import { LOYALTY, loyalty } from "./loyalty";
import { DECLINED_TRANSACIONS, declinedTransactions } from "./declinedTransactions";

Vue.use(Vuex);

const store: StoreOptions<IRootState> = {
  strict: process.env.NODE_ENV !== "production",
  // todo - make the modules self registering.
  modules: {
    [ADDRESS_LOOKUP.NAME_SPACE]: addressLookup,
    [APPLICATION.NAME_SPACE]: application,
    [DECLINED_TRANSACIONS.NAME_SPACE]: declinedTransactions,
    [AUTH.NAME_SPACE]: auth,
    [PROMO_CODES.NAME_SPACE]: promoCodes,
    [REFERENCE_DATA.NAME_SPACE]: referenceData,
    [STANDARD_OFFER.NAME_SPACE]: standardOffer,
    [TASK.NAME_SPACE]: task,
    [UI.NAME_SPACE]: ui,
    [LOYALTY.NAME_SPACE]: loyalty,
  }
};

export default new Vuex.Store<IRootState>(store);
